import { Box, Typography, Button } from "@mui/material";
import Image from "@/components/image";
import CongratsIcon from "@/assets/illustrations/success.gif";
import { useActivePhase } from "../useActivePhase";
import { animationFor } from "../sectionAnimation";

type CourseSectionProps = {
  course: { name?: string; title?: string };
  isActive: boolean;
  onAdvance: () => void;
  isLast: boolean;
};

export const CourseSection = ({
  course,
  isActive,
  onAdvance,
  isLast,
}: CourseSectionProps) => {
  const phase = useActivePhase(isActive);
  const name = course.name || course.title || "your course";
  return (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#fff",
        borderRadius: 2,
        padding: "48px 24px",
        maxWidth: 600,
        width: "95%",
        animation: animationFor(phase),
      }}
    >
      <Typography variant="h3" fontFamily="Nunito" fontWeight="700">
        Course Complete!
      </Typography>
      <Image
        alt="course completion celebration"
        src={CongratsIcon}
        sx={{ width: 144, height: 144, mt: 2, mb: 2 }}
      />
      <Typography variant="h6" fontFamily="ProximaNova Bold" sx={{ mb: 4 }}>
        You finished {name}
      </Typography>
      <Button
        color="primary"
        variant="contained"
        fullWidth
        sx={{ height: 48 }}
        onClick={onAdvance}
      >
        {isLast ? "Keep Climbing" : "Next"}
      </Button>
    </Box>
  );
};
